let hotspotsInitialRender = true

if (!customElements.get('hotspot-images')) {
  customElements.define(
    'hotspot-images',
    class HotspotImages extends HTMLElement {
      constructor() {
        super();
        this.productId = this.dataset.productId
        this.colorScheme = this.dataset.colorScheme
        this.showHeadings = this.dataset.showHeading === "true"
      }

      connectedCallback() {
        this.hotspotsProductsContainer = document.querySelector('.hotspot-item-products-list')

        if (hotspotsInitialRender && this.hotspotsProductsContainer) {
          this.assignHotspotsContent()
          this.moveContentToBottomSheet()
        } else {
          CustomUtilities.waitForMutationsEnd(this, () => {
            this.assignHotspotsContent()
            this.moveContentToBottomSheet()
          })
        }

        hotspotsInitialRender = false
      }

      assignHotspotsContent() {
        this.bottomSheetContentContainer = document.querySelector(`#bottom-sheet-content-${this.productId}`)
        this.bottomSheetTopBarContainer = document.querySelector(`#bottom-sheet-top-bar-${this.productId}`)
        
        this.hotspotsProductsContainer = document.querySelector('.hotspot-item-products-list')
        this.hotspotsAllToCartButton = document.querySelector('.alltocartall')
        this.hotspotsImages = this?.querySelectorAll('img:not(.kt-image-item-main)')
        this.hotspotTitle = document.querySelector('.kt__header > h2 > span')?.textContent
        this.hotspotDescription = document.querySelector('.kt__header > .kt__subtitle')?.textContent
        this.prices = document.querySelectorAll('.hotspot-item-price')

        if (this.hotspotsImages?.length) {
          this.fixImagesQuality(this.hotspotsImages, 620)
        }
        this.addSoldOutLabels()
      }

      fixImagesQuality(images, quality = 360) {
        images.forEach((image) => {
          const src = image.src
          image.src = src.replace('&width=140', `&width=${quality}`)
          const clonedImage = image.cloneNode()
          clonedImage.classList.add('hotspots__cloned-image')
          image.after(clonedImage)
        })
      }

      addSoldOutLabels() {
        this.prices.forEach((price) => {
          if (!price.children.length) {
            const span = document.createElement('span');
            span.classList.add('hotspot__sold-out');
            span.textContent = window.variantStrings.soldOut;

             price.appendChild(span);
          }
        }); 
      }

      moveContentToBottomSheet() {
        const bottomSheetObserver = new MutationObserver((mutationList, observer) => {
          for (const mutation of mutationList) {
            if (mutation.type === "childList") {
              this.bottomSheetContentContainer = document.querySelector(`#bottom-sheet-content-${this.productId}`)
              this.bottomSheetTopBarContainer = document.querySelector(`#bottom-sheet-top-bar-${this.productId}`)

              if (this.colorScheme) {
                this.bottomSheetContentContainer.classList.add(`color-${this.colorScheme}`)
              }

              if (this.bottomSheetContentContainer && this.bottomSheetTopBarContainer) {
                this.bottomSheetContentContainer.append(this.hotspotsProductsContainer)
               
                if(this.hotspotsAllToCartButton) {
                  this.bottomSheetContentContainer.append(this.hotspotsAllToCartButton)
                }

                if (this.hotspotTitle && this.showHeadings) {
                  const bottomSheetTopBarTitle = this.bottomSheetTopBarContainer.querySelector('.modal-popup__titles > h1')
                  bottomSheetTopBarTitle.append(this.hotspotTitle)
                }

                if (this.hotspotDescription && this.showHeadings) {
                  const bottomSheetTopBarSubtitle = this.bottomSheetTopBarContainer.querySelector('.modal-popup__titles > h2')
                  bottomSheetTopBarSubtitle.append(this.hotspotDescription)
                }

                this.hotspotsProductsContainer.classList.remove('hidden')

                observer.disconnect()
                break;
              }
            }
          }
        })

        bottomSheetObserver.observe(document, { childList: true, subtree: true })
      }
    }
  );
}
